export * from "./bet-config";
export { default as BetQLService } from "./bet-services";
